module.exports = __webpack_public_path__ + "media/img/illustrations/avatar-placeholder-a17e7a4a56fba99f25d3dad30f8bdd6b.svg";